import ExpiredContainer from './ExpiredContainer';

export default ExpiredContainer;